import React, { useEffect, useState } from "react";
import Breadcrumb from "../../component/breadcrumb/Breadcrumb";
import { useParams } from "react-router-dom";
import config from "../../config";
import { triggerNotification } from "../../component/message/Msg";
import Spinner from "../../component/loadingbar/Spinner";
import moment from "moment";
import noImg from "../../assetsCon/assets/images/noImg.png";
import Swal from "sweetalert2";

const ViewTeacher = () => {
  const { id, coid, aprvl } = useParams();
  const token = config.token;
  const [loading, setLoading] = useState(false);
  const [teacherData, setTeacherData] = useState({
    fname: "",
    lname: "",
    username: "",
    email: "",
    mobileno: "",
    address: "",
    image: "",
    gender: "",
    joining_date: "",
    dob: "",
    isactive: "",
  });

  const fetchTeacherData = async () => {
    setLoading(true);
    try {
      await fetch(`${config.host_url}teacher/${decodeURIComponent(atob(id))}`, {
        method: "GET",
        headers: {
          token: token,
        },
      })
        .then((response) => response.json())
        .then(async (data) => {
          if (data.status === 200) {
            await setTeacherData(data.data);
          }
        });
    } catch (error) {
      triggerNotification("error", "Error occurs in fetch data.");
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id !== undefined) {
      fetchTeacherData(id);
    }
  }, [id]);

  //----------------------------------------------- enable - disable teacher -----------------------------------------------
  const enabledisableTeacherBtn = () => {
    Swal.fire({
      title: "Are you sure?",
      text: `You are about to ${
        teacherData.isApproved === "0" || teacherData.isApproved === 0
          ? "approve"
          : "reject"
      } teacher?. Are you sure you want to proceed?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, ${
        teacherData.isApproved === "0" || teacherData.isApproved === 0
          ? "approve"
          : "reject"
      } it!`,
    }).then((result) => {
      if (result.isConfirmed) {
        enabledisableTeacher();
      }
    });

    //If confirm then enable/ disable teacher
    const enabledisableTeacher = async () => {
      try {
        await fetch(
          `${config.host_url}teacher/approved/${decodeURIComponent(atob(id))}/${
            teacherData.isApproved === "0" || teacherData.isApproved === 0
              ? "1"
              : "0"
          }`,
          {
            method: "GET",
            headers: {
              token: token,
            },
          }
        )
          .then((response) => response.json())
          .then(function (data) {
            if (data.status === 200) {
              triggerNotification(
                "success",
                `Teacher ${
                  teacherData.isApproved === "0" || teacherData.isApproved === 0
                    ? "approved"
                    : "rejected"
                } successfully`
              );
              setTeacherData((prevData) => ({
                ...prevData,
                isApproved:
                  teacherData.isApproved === "0" || teacherData.isApproved === 0
                    ? "1"
                    : "0",
              }));
            } else if (data.status === 404) {
              // teacher IDs Not Found
              console.error("Teacher ID is not found");
              triggerNotification("error", "Teacher ID is not found");
            } else if (data.status === 401) {
              // Invalid Token
              console.error("Invalid token");
              triggerNotification("error", "Unauthenticated User");
            } else {
              // Internal Server Error or other HTTP errors
              console.error("Internal server error");
              triggerNotification(
                "error",
                "Internal server error, Please try after some time!"
              );
            }
          });
      } catch (error) {
        console.error("Error enabling teacher", error);
        triggerNotification("error", "Error enabling teacher");
      }
    };
  };
  return (
    <>
      {coid ? (
        <Breadcrumb
          txt="Manage Course"
          subpath={["View Courses", "Course Details", "Teacher Details"]}
          url={["/viewcourses", `/viewcourse/${coid}`]}
        />
      ) : decodeURIComponent(atob(id)) === "0" ? (
        <Breadcrumb txt="Account Settings" subpath={["My Profile"]} />
      ) : aprvl ? (
        <Breadcrumb
          txt="Manage Teacher"
          subpath={["Teacher For Approval", "Teacher Details"]}
          url={["/tcrforaprvl"]}
        />
      ) : (
        <Breadcrumb
          txt="Manage Teacher"
          subpath={["View Teachers", "Teacher Details"]}
          url={["/viewteachers"]}
        />
      )}

      {loading ? (
        <Spinner />
      ) : (
        <div className="container-xxl flex-grow-1 container-p-y mt-12">
          <div className="row">
            <div className="col-12">
              <div className="card mb-4">
                <div className="user-profile-header d-flex flex-column flex-sm-row text-sm-start text-center mb-4">
                  <div className="flex-shrink-0 mt-n2 mx-sm-0 mx-auto">
                    <img
                      src={teacherData.image ? teacherData.image : noImg}
                      alt="user image"
                      className="d-block h-[7.5rem] bg-gray-300 ms-0 ms-sm-4 border-white rounded user-profile-img"
                    />
                  </div>
                  <div className="flex-grow-1 mt-3 mt-sm-5">
                    <div className="d-flex align-items-md-end align-items-sm-start align-items-top justify-content-md-between justify-content-start mx-4 flex-md-row flex-column gap-4">
                      <div className="user-profile-info">
                        <h4>
                          {teacherData.fname + " " + teacherData.lname}
                          {teacherData.incentive !== null && (
                            <span className="text-gray-400 ml-4 font-light	text-sm	">
                              ( Third Party Teacher )
                            </span>
                          )}
                          <button
                            type="button"
                            className={`btn btn-${
                              teacherData.isApproved === "0" ||
                              teacherData.isApproved === 0
                                ? "primary"
                                : "secondary"
                            } ml-5 btn-sm w-40   `}
                            onClick={() => {
                              enabledisableTeacherBtn();
                            }}
                          >
                            {teacherData.isApproved === "0" ||
                            teacherData.isApproved === 0
                              ? "Approve Teacher"
                              : "Reject Teacher"}
                          </button>
                        </h4>

                        <ul className="list-inline mb-0 d-flex align-items-top flex-wrap justify-content-sm-start justify-content-center gap-2">
                          <li className="list-inline-item">
                            <i className="mdi mdi-account  form-icon me-1 mdi-20px"></i>
                            <span className="fw-medium">
                              {teacherData.username}
                            </span>
                          </li>
                          <li className="list-inline-item">
                            <i className="mdi mdi-map-marker-outline me-1 mdi-20px"></i>
                            <span className="fw-medium">
                              {teacherData.address.length > 20
                                ? teacherData.address.slice(0, 18) + "..."
                                : teacherData.address}
                            </span>
                          </li>
                          <li className="list-inline-item">
                            <i className="mdi mdi-calendar-blank-outline me-1 mdi-20px"></i>
                            <span className="fw-medium">
                              Joined{" "}
                              {moment(teacherData.joining_date).format(
                                "Do MMMM YYYY"
                              )}
                            </span>
                          </li>
                        </ul>
                      </div>
                      <a
                        className={` ${
                          teacherData.isactive === "1"
                            ? "bg-blue-400 px-3 py-2 rounded text-white font-bold "
                            : "bg-gray-400 px-3 py-2 rounded text-white font-bold"
                        }`}
                      >
                        <i
                          className={`mdi mdi-account-${
                            teacherData.isactive === "1"
                              ? "check-outline"
                              : "off"
                          } me-1`}
                        ></i>
                        {teacherData.isactive === "1" ? "Active" : "Not Active"}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="card mb-4">
            <div className="card-body row">
              <div className="col-md-6">
                <small className="card-text text-uppercase">About</small>
                <ul className="list-unstyled my-3 py-1">
                  <li className="d-flex align-items-top mb-3">
                    <i className="mdi mdi-account-outline mdi-24px"></i>
                    <span className="fw-medium mx-2">Full Name:</span>{" "}
                    <span>{teacherData.fname + " " + teacherData.lname}</span>
                  </li>
                  <li className="d-flex align-items-top mb-3">
                    <i className="mdi mdi-check mdi-24px"></i>
                    <span className="fw-medium mx-2">Status:</span>{" "}
                    <span>
                      {teacherData.isactive === "1" ? "Active" : "Not Active"}
                    </span>
                  </li>

                  <li className="d-flex align-items-top mb-3">
                    <i className="mdi mdi-map-marker-outline mdi-24px"></i>
                    <span className="fw-medium mx-2">Address:</span>{" "}
                    <span>{teacherData.address}</span>
                  </li>
                  <li className="d-flex align-items-top mb-3">
                    <i className="mdi mdi-cake mdi-24px"></i>
                    <span className="fw-medium mx-2">DOB:</span>{" "}
                    <span>
                      {moment(teacherData.dob).format("MMMM Do YYYY")}
                    </span>
                  </li>
                </ul>
              </div>
              <div className="col-md-6">
                <small className="card-text text-uppercase">Contacts</small>
                <ul className="list-unstyled my-3 py-1">
                  <li className="d-flex align-items-top mb-3">
                    <i className="mdi mdi-phone-outline mdi-24px"></i>
                    <span className="fw-medium mx-2">Contact:</span>{" "}
                    <span>{teacherData.mobileno}</span>
                  </li>
                  <li className="d-flex align-items-top mb-3">
                    <i className="mdi mdi-email-outline mdi-24px"></i>
                    <span className="fw-medium mx-2">Email:</span>{" "}
                    <span>{teacherData.email}</span>
                  </li>
                </ul>
                {teacherData.incentive !== null && (
                  <>
                    <small className="card-text text-uppercase">Other</small>
                    <ul className="list-unstyled my-3 py-1">
                      <li className="d-flex align-items-top mb-3">
                        <i className="mdi mdi-gift-outline mdi-24px"></i>
                        <span className="fw-medium mx-2">Incentive:</span>{" "}
                        <span>
                          {teacherData.incentive && teacherData.incentive}
                        </span>
                      </li>
                    </ul>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ViewTeacher;
